import { branch, renderComponent } from 'recompose'

import LoginSignUpContainer from 'shared/components/LoginSignUpContainer'
import { CardSection } from '@components/CardSection'
import Button from '@components/Button'

import { userSelector } from 'auth/selectors'
import { DATE_FORMAT } from 'shared/constants'
import CircleLoader from 'shared/components/CircleLoader'

import { firstDayOfTheMonth } from 'shared/utils'

import purchaseStyles from 'purchase-flow/styles.module.scss'

const WaitlistDateSelection = ({ waitlistAvailable, waitlistState, onNext, errorMsg }) => {
    const onNextClick = () => {
        onNext({ value: firstDayOfTheMonth(), displayValue: firstDayOfTheMonth().format(DATE_FORMAT) })
    }

    return (
        <CardSection className={purchaseStyles.contentSection} loading={false}>
            {errorMsg ? (
                <h3>{errorMsg}</h3>
            ) : !waitlistState ? (
                <div className="row justify-content-center">
                    <CircleLoader />
                </div>
            ) : (
                waitlistAvailable && (
                    <h3 className="text-uppercase">
                        <T>waiting.list.date.section.spot.available.label</T> {firstDayOfTheMonth().format(DATE_FORMAT)}
                    </h3>
                )
            )}
            <div className="d-flex justify-content-end">
                <Button btnStyle="primary" onClick={onNextClick} disabled={!waitlistAvailable}>
                    <T>subscription.purchase.label.next</T>
                </Button>
            </div>
        </CardSection>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            user: userSelector,
        })
    ),
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent(WaitlistDateSelection))
)(WaitlistDateSelection)
